export default "__VITE_ASSET__DY$MRHKC__"